/**
 * Labstep
 *
 * @module components/Experiment/Action/End/WithCheck
 * @desc Action to finish experiment with completion checklist
 */

import { ExperimentActionEnd } from 'labstep-web/components/Experiment/Action/End';
import { ExperimentCompletionChecklistModal } from 'labstep-web/components/Experiment/CompletionChecklist/Modal';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import type React from 'react';
import type { ExperimentActionEndWithCheckProps } from './types';

export const ExperimentActionEndWithCheck: React.FC<
  ExperimentActionEndWithCheckProps
> = ({ experiment, options = {}, actionType, activeGroup }) => {
  if (!activeGroup) {
    return null;
  }
  if (activeGroup.is_completion_checklist_enabled) {
    return (
      <ExperimentCompletionChecklistModal
        experiment={experiment}
        actionType={actionType}
      />
    );
  }
  return (
    <ExperimentActionEnd
      experiment={experiment}
      actionType={actionType}
      options={options}
    />
  );
};

export default withActiveGroup(ExperimentActionEndWithCheck);
